import { useCallback, useEffect, useState } from "react";
import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";
import { getMedicaluserByRole } from "../../../utils/apis/medical-user-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { ExpertRole } from "../../../utils/Enums";

export const useGetNutritionists = () => {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    const [nutritionists, setNutritionists] = useState<CalendlyExpert[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchNutritionists = useCallback(async () => {
        if (!idToken) return;
        setIsLoading(true);
        setError(null);

        try {
            const result: CalendlyExpert[] | null = await getMedicaluserByRole(idToken, ExpertRole.Nutritionist);
            if (result !== null) {
                setNutritionists(result);
            }
        } catch (err: any) {
            console.error("Failed to fetch nutritionists:", err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [idToken]);

    useEffect(() => {
        fetchNutritionists();
    }, [fetchNutritionists]);

    return { nutritionists, isLoading, error, refetch: fetchNutritionists };
}